export const checkboxColumnCover = {
    id: 'checkbox',
    spacing: '4 0',
    width: 28,
} as const;
